import { render, staticRenderFns } from "./BarcodeMatching.vue?vue&type=template&id=0604f3b4"
import script from "./BarcodeMatching.vue?vue&type=script&lang=js"
export * from "./BarcodeMatching.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports